module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/toggle/toggle.item.template.html
// module id = 974
// module chunks = 0